import * as React from 'react';

export function IconDiners(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 54 32" fill="none" {...props}>
      <title>Diners Club</title>
      <g clipPath="url(#prefix__clip0_16_19)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0h53.333v32H0V0z"
          fill="#fff"
        />
        <path
          d="M28.975 25.562c5.19.025 9.927-4.271 9.927-9.498 0-5.715-4.737-9.666-9.927-9.664h-4.467c-5.252-.002-9.575 3.95-9.575 9.664 0 5.228 4.323 9.523 9.575 9.498h4.467z"
          fill="#0079BE"
        />
        <path
          d="M24.53 7.192c-4.8.002-8.688 3.927-8.69 8.772.002 4.844 3.89 8.77 8.69 8.77 4.8 0 8.69-3.926 8.69-8.77 0-4.845-3.89-8.77-8.69-8.772zm-5.508 8.772a5.568 5.568 0 013.536-5.189v10.376a5.565 5.565 0 01-3.536-5.187zm7.479 5.19v-10.38a5.564 5.564 0 013.538 5.19 5.567 5.567 0 01-3.538 5.19z"
          fill="#fff"
        />
        <path
          d="M28.975 25.562c5.19.025 9.927-4.271 9.927-9.498 0-5.715-4.737-9.666-9.927-9.664h-4.467c-5.252-.002-9.575 3.95-9.575 9.664 0 5.228 4.323 9.523 9.575 9.498h4.467z"
          fill="#0079BE"
        />
        <path
          d="M24.53 7.192c-4.8.002-8.688 3.927-8.69 8.772.002 4.844 3.89 8.77 8.69 8.77 4.8 0 8.69-3.926 8.69-8.77 0-4.845-3.89-8.77-8.69-8.772zm-5.508 8.772a5.568 5.568 0 013.536-5.189v10.376a5.565 5.565 0 01-3.536-5.187zm7.479 5.19v-10.38a5.564 5.564 0 013.538 5.19 5.567 5.567 0 01-3.538 5.19z"
          fill="#fff"
        />
      </g>
      <defs>
        <clipPath id="prefix__clip0_16_19">
          <path fill="#fff" d="M0 0h53.333v32H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
